import React, { useContext, useState } from 'react';

import { Card } from '../../../../../../../components/v2/Card';
import InputLabel from '../../../../../../../components/v2/InputLabel';
import LoadingOverlay from '../../../../../../components/LoadingOverlay';
import ExternalCoachContext from '../../../../../../context/ExternalCoachContext';
import useToast from '../../../../../../hooks/useToast';
import useComponentMounted from '../../../../../../../hooks/useComponentMounted';

import texts from './texts.json';
import {
  StyledButton,
  StyledSaveIcon,
  StyledSelect,
} from './styles';

// These are the only options available for the base fee.
const BaseFeeOptions = [{
  value: 25,
  label: 25,
}, {
  value: 30,
  label: 30,
}];

const InternalConfigs = () => {
  const { externalCoachDoc } = useContext(ExternalCoachContext);
  const [baseFee, setBaseFee] = useState(externalCoachDoc.baseFee || '');
  const [isSaving, setIsSaving] = useState(false);
  const isComponentMountedRef = useComponentMounted();

  const { showToast } = useToast();

  const onSave = async () => {
    setIsSaving(true);
    await externalCoachDoc.set({
      ...(baseFee && { baseFee: Number(baseFee) }),
    }, { merge: true });
    showToast(texts.success, { success: true });
    if (isComponentMountedRef.current) {
      setIsSaving(false);
    }
  };

  return (
    <Card>
      <InputLabel>{texts.fieldNames.baseFee}</InputLabel>
      <StyledSelect
        onChange={(e) => setBaseFee(e.target.value)}
        value={baseFee}
        renderValue={(value) => value && `${value} %`}
        options={BaseFeeOptions}
      />
      <StyledButton onClick={onSave}>
        <StyledSaveIcon />
        {texts.save}
      </StyledButton>
      <LoadingOverlay isLoading={isSaving} />
    </Card>
  );
};

export default InternalConfigs;
